exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".jumbotron[data-v-5dae89c0]{background:#e9ecef}", ""]);

// exports
